import Mutations from '../../odata/mutations';

export default { ...new Mutations('tip'), ...new Mutations('tips') };
